// ==============================================

//        NAV FUNCTIONS

// ==============================================

document.addEventListener('DOMContentLoaded', function (e) {

    var btnBurger = document.getElementById('btn-burger');
    var btnBurger__icon = document.getElementById('btn-burger__icon');
    var header = document.getElementById('header');
    var headerRow1 = document.getElementById('header-row1');
    var headerRow2 = document.getElementById('header-row2');
    var blockJob = document.querySelector('.block-job');

    //        Show / Hide responsive nav
    // ==============================================
    function toggleNavResponsive(e) {
        e.preventDefault();
        document.body.classList.toggle('no-scroll');
        btnBurger__icon.classList.toggle('is-active');
        headerRow2.classList.toggle('is-open');
        headerRow2.classList.add('has-transition');
    }

    btnBurger.addEventListener('click', toggleNavResponsive);


    // reset button states (remove nav transition when switch to resolution)
    function closeNavResponsive() {
        document.body.classList.remove('no-scroll');
        btnBurger__icon.classList.remove('is-active');
        headerRow2.classList.remove('is-open');
        headerRow2.classList.remove('has-transition');
    }


    // get document coordinates of the element relative to the document
    function getCoords(el) {
        let rect = el.getBoundingClientRect();

        return {
            top: rect.top + window.pageYOffset,
            left: rect.left + window.pageXOffset
        };
    }


    //        Stick header 1st row on top when scroll (mobile)
    // ==============================================

    var lastScroll = 0;

    function toggleStickyHeaderMobile() {
        var currentScroll = document.body.scrollTop || document.documentElement.scrollTop;
        var limit = 0;
        if (blockJob && !blockJob.classList.contains('is-closed')) {
            limit += blockJob.offsetHeight;
        }
        (currentScroll > limit) ? header.classList.add('is-sticky-mobile') : header.classList.remove('is-sticky-mobile');

        // scroll down -> hide  / scroll up -> show
        (currentScroll > limit + 200 && currentScroll > lastScroll) ? header.classList.add('is-close') : header.classList.remove('is-close');
        lastScroll = currentScroll;
    }


    //        Stick header 2nd row on top when scroll (desktop)
    // ==============================================

    function toggleStickyHeaderDesktop() {
        var currentScroll = document.body.scrollTop || document.documentElement.scrollTop;
        var limit = headerRow1.offsetHeight;
        if (blockJob && !blockJob.classList.contains('is-closed')) {
            limit += blockJob.offsetHeight;
        }

        (currentScroll > limit) ? header.classList.add('is-sticky-desktop') : header.classList.remove('is-sticky-desktop');
    }


    //        Update menu behaviour with matchmedia
    // ==============================================

    // Check if in small screen
    function detectSmallScreen(e) {
        if (e.matches) {
            window.addEventListener('scroll', toggleStickyHeaderMobile);
            header.classList.remove('is-sticky-desktop');
            // console.log('small');
        }
    }

    // Check if in medium screen
    function detectMediumScreen(e) {
        if (e.matches) {
            window.removeEventListener('scroll', toggleStickyHeaderDesktop);
            header.classList.remove('is-sticky-desktop');

            window.addEventListener('scroll', toggleStickyHeaderMobile);
            // console.log('medium');
        }
    }

    // Check if in large screen
    function detectLargeScreen(e) {
        if (e.matches) {
            window.removeEventListener('scroll', toggleStickyHeaderMobile);
            header.classList.remove('is-sticky-mobile');
            header.classList.remove('is-close');    // in case header is still hidden when scroll down on mobile
            closeNavResponsive();                   // in case responsive nav is still opened

            window.addEventListener('scroll', toggleStickyHeaderDesktop);
            // console.log('large');
        }
    }

    // media query event handler
    var smallMq = window.matchMedia("(max-width: 640px)");
    var mediumMq = window.matchMedia("(min-width: 640px) and (max-width: 1024px)");
    var largeMq = window.matchMedia("(min-width: 1024px)");

    smallMq.addListener(detectSmallScreen);
    mediumMq.addListener(detectMediumScreen);
    largeMq.addListener(detectLargeScreen);

    // run once
    detectSmallScreen(smallMq);
    detectMediumScreen(mediumMq);
    detectLargeScreen(largeMq);


    //        Open / Close language switcher dropdown
    // ==============================================
    var langSwitcherList = document.getElementById('lang-switcher__list');
    var langSwitcherBtn = document.getElementById('lang-switcher__btn');

    function openLangDropdown(e) {
        e.preventDefault();
        langSwitcherList.classList.add('is-open');
        langSwitcherBtn.removeEventListener('click', openLangDropdown);
        langSwitcherBtn.addEventListener('click', closeLangDropdown);
        document.addEventListener('click', clickOutsideLangDropdown);
    }

    function closeLangDropdown(e) {
        e.preventDefault();
        langSwitcherList.classList.remove('is-open');
        langSwitcherBtn.removeEventListener('click', closeLangDropdown);
        langSwitcherBtn.addEventListener('click', openLangDropdown);
        document.removeEventListener('click', clickOutsideLangDropdown);
    }

    langSwitcherBtn.addEventListener('click', openLangDropdown);

    function clickOutsideLangDropdown(e) {
        // console.log('\nclickOutsideLangDropdown');
        if (!langSwitcherList.contains(e.target) &&
            !langSwitcherBtn.contains(e.target)) {
            // console.log("close dropdown");
            closeLangDropdown(e);
        }
    }


    //        Open / Close pop-in social
    // ==============================================
    var popSocial = document.getElementById('pop-social');

    function openPopSocial(e) {
        e.preventDefault();
        popSocial.classList.add('is-open');
        document.body.classList.add('no-scroll');
        popSocial.querySelector('.pop-social__overlay').addEventListener('click', closePopSocial);
        popSocial.querySelector('.btn-close').addEventListener('click', closePopSocial);
    }

    function closePopSocial(e) {
        e.preventDefault();
        popSocial.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
        popSocial.querySelector('.pop-social__overlay').removeEventListener('click', closePopSocial);
        popSocial.querySelector('.btn-close').removeEventListener('click', closePopSocial);
    }

    document.getElementById('btn-follow').addEventListener('click', openPopSocial);
    document.getElementById('link-follow').addEventListener('click', openPopSocial);


    //        Open / Close pop-in shortlink
    // ==============================================
    var popShortlink = document.getElementById('pop-shortlink');

    function openPopShortlink(e) {
        e.preventDefault();
        popShortlink.classList.add('is-open');
        document.body.classList.add('no-scroll');
        popShortlink.querySelector('.pop-shortlink__overlay').addEventListener('click', closePopShortlink);
        popShortlink.querySelector('.btn-close').addEventListener('click', closePopShortlink);
    }

    function closePopShortlink(e) {
        e.preventDefault();
        popShortlink.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
        popShortlink.querySelector('.pop-shortlink__overlay').removeEventListener('click', closePopShortlink);
        popShortlink.querySelector('.btn-close').removeEventListener('click', closePopShortlink);

        // hide confirm message
        popShortlink.querySelector('.pop-shortlink__confirm').classList.remove('is-show');
    }

    // copy shortlink url
    function copyShortLink(e) {
        var copyText = document.getElementById("pop-shortlink__url");
        copyText.select();
        copyText.setSelectionRange(0, 99999);   // For mobile devices
        document.execCommand("copy");
        window.getSelection().removeAllRanges();

        // show confirm message
        popShortlink.querySelector('.pop-shortlink__confirm').classList.add('is-show');
    }

    if (popShortlink) {
        document.querySelector('.btn-share--shortlink').addEventListener('click', openPopShortlink);
        popShortlink.querySelector('.btn-copy').addEventListener('click', copyShortLink);
    }


    //        Close banner job
    // ==============================================

    // Close banner job when click and set cookie
    function closeBannerJob(e) {
        blockJob.classList.add('is-closed');

        setCookie("bannerjob", "0", 1, "/");
        // setCookie("bannerjob", "0", new Date(new Date().getTime() + 10000), "/");
    }

    // Check if banner job cookie exist (if user close banner)
    function checkBannerJobCookie() {
        var cookie = getCookie("bannerjob");
        console.log('•cookie', cookie);

        // user already close the banner -> close banner
        if (cookie == 0) {
            blockJob.classList.add('is-closed');
            // no cookie set -> show banner
        } else {
            blockJob.classList.remove('is-closed');
        }
    }

    // Check if banner job cookie exist
    if (blockJob) {
        // listCookies();
        checkBannerJobCookie();
        blockJob.querySelector('.btn-close').addEventListener('click', closeBannerJob);
    }


    // ∆∆∆∆∆∆∆∆∆∆
    // document.getElementById('btn-follow').addEventListener('click', function(e) {
    //   deleteCookie('bannerjob');
    // });


    //        Cookie for banner job
    // ==============================================
    // create cookie
    function setCookie(name, value, expires, path, domain) {
        var cookie = name + "=" + escape(value) + ";";

        if (expires) {
            // expires param is a date
            if (expires instanceof Date) {
                // If it isn't a valid date
                if (isNaN(expires.getTime())) expires = new Date();
                // expires param is the number of days
            } else {
                // console.log('nb day', expires);
                expires = new Date(new Date().getTime() + parseInt(expires) * 24 * 60 * 60 * 1000);
            }
            cookie += "expires=" + expires.toUTCString() + ";";
        }

        if (path) cookie += "path=" + path + ";";
        if (domain) cookie += "domain=" + domain + ";";
        document.cookie = cookie;
    }


    // return cookie value if exist
    function getCookie(name) {
        var nameEQ = name + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        // parse each cookie couple
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            // remove prepending spaces
            while (c.charAt(0) == ' ') c = c.substring(1);
            // return value of cookie
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;    // no cookie found
    }


    // delete cookie by name if exist
    function deleteCookie(name, path = '/', domain = '') {
        if (getCookie(name)) {
            setCookie(name, '', -1, path, domain);
            console.log('deleteCookie', name);
        } else {
            console.log('no cookie with this name');
        }
    }


    // list all cookie in a site
    function listCookies() {
        let cookies = document.cookie.split(';');
        let list = '';
        cookies.map((cookie, n) => list += `${n}: ${decodeURIComponent(cookie)}\n`);
        // old sys
        // for (let i = 0 ; i < cookies.length; i++) {
        //   list += `${i}: ${decodeURIComponent(cookies[i])}\n`;
        // }
        console.log('listCookies\n' + list);
    }


    // return cookie value if exist
    function getCookieSimple(name) {
        var regexp = new RegExp("(?:^" + name + "|;\s*" + name + ")=(.*?)(?:;|$)", "g");
        var result = regexp.exec(document.cookie);
        return (result === null) ? null : result[1];
    }


    //        Wow scroll reveal animations
    // ==============================================

    function initWow() {
        var my_offset = 80;

        // params for mobile
        if (window.innerWidth < 680) {
            my_offset = 10;

            // remove delay for all animations
            $('[data-wow-delay]').removeAttr('data-wow-delay');
        }

        var wow = new WOW({
            offset: my_offset
            // mobile: false,
        });
        wow.init();
    }

    initWow();


    // close responsive menu if still open on large screens
    function checkNavResponsive() {
        // CSS Media Query width == window.innerWidth including scrollbars (NOT document.documentElement.clientWidth)
        if (window.innerWidth >= 1024) closeNavResponsive();
    }

    // window.addEventListener('resize', checkNavResponsive);


    //        Form newsletter
    // ==============================================

    function emailIsValid(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    if ($('.form-newsletter').length) {
      $('.form-newsletter').submit(function (e) {
        e.preventDefault();
        var url_form        = COMMUNITY_URL+'/newsletter/subscription/';
        var form            = $(this);
        var feedback        = $(form).next('.form-newsletter__feedback');
        var email_input     = $(form).find('input[name="email"]');
        var email           = $(email_input).val();
        var error_email_msg = newsletter_messages.email;
        var send_msg        = newsletter_messages.sending;
        var confirm_msg     = newsletter_messages.success;
        var error_msg       = newsletter_messages.error;

        // check email validation
        if (!emailIsValid(email)) {
          $(feedback).addClass('is-show').text(error_email_msg);
          return;
        }

        // prepare to send data
        $(feedback).addClass('is-show').text(send_msg);

        $.ajax({
          data: {
              email: email,
              action: 'submit_newsletter',
              lang: $('#lang-switcher__btn').text().replace(/\n| /gi,'')
          },
          crossdomain: true,
          type: 'post',
          url: url_form
        })
        .done(function () {
          $(feedback).addClass('is-show').text(confirm_msg);
          $(email_input).val('');
          $(email_input).focus(function() {
            $(feedback).removeClass('is-show').text('');
          });
        })
        .fail(function (xhr, textStatus, errorThrown) {
          if(xhr.status === 400) {
              // subscription already exists
              // todo to translate
              // error_msg = 'Vous êtes déjà inscrit à la newsletter Chargemap';
          }

          $(feedback).addClass('is-show').text(error_msg);
          $(email_input).focus(function() {
            $(feedback).removeClass('is-show').text('');
          });
        });
      })
    }


    //        Polyfill for object-fit ( IE 11 )
    // ==============================================

    objectFitImages();

})
